<div class="card h-full">
  <div class="card-header">
    <h3 class="card-title text-black dark:text-white">Log</h3>
  </div>
  <div class="card-body p-0">
    <kendo-grid
      [kendoGridBinding]="repState.repNotes"
      (edit)="editHandler($event)"
      (add)="addHandler($event)"
      (save)="saveHandler($event)"
      (cancel)="cancelHandler($event)"
    >
      <ng-template kendoGridToolbarTemplate>
        <div class="flex items-center p-2">
          <button gdAdminOnly
            type="button"
            kendoGridAddCommand
            kendoButton
            look="flat"
            icon="plus"
            class="mr-2"
          >
            Add New Record
          </button>
          <button gdAdminOnly
            type="button"
            kendoButton
            look="flat"
            icon="refresh"
            class="ml-auto"
          >
            Refresh
          </button>
        </div>
      </ng-template>
      <kendo-grid-column field="entryDate" title="Entry Date" width="75">
        <ng-template kendoGridCellTemplate let-column>
          {{ column.entryDate | date : 'MM/dd/yyyy' }}
        </ng-template>
        <ng-template
          kendoGridEditTemplate
          let-dataItem="dataItem"
          let-column="column"
          let-formGroup="formGroup"
        >
          <kendo-datepicker
            class="k-adjust-width"
            type="date"
            [formControl]="formGroup.get(column.field)"
            format="MM/dd/yyyy"
            [formatPlaceholder]="
              asDateInput({ year: 'YYYY', month: 'MM', day: 'DD' })
            "
          ></kendo-datepicker>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="noteType" title="Type" width="120">
        <ng-template
          kendoGridEditTemplate
          let-dataItem="dataItem"
          let-column="column"
          let-formGroup="formGroup"
        >
          <kendo-dropdownlist
            class="w-full"
            [data]="activeNoteTypeList"
            textField="noteTypeDescription"
            valueField="noteTypeId"
            valuePrimitive="true"
            [formControl]="formGroup.get('noteTypeId')"
            [popupSettings]="{ height: 200 }"
          >
          </kendo-dropdownlist>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="noteMemo" title="Memo" width="280">
        <ng-template
          kendoGridEditTemplate
          let-column="column"
          let-formGroup="formGroup"
          let-isNew="isNew"
        >
          <textarea
            autoSize="true"
            class="k-input w-full"
            style="min-height: 80px;"
            [formControl]="formGroup.get(column.field)"
            kendoTextArea
          ></textarea>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="followup" title="Follow Up" width="40">
        <ng-template kendoGridCellTemplate let-column>
          <input type="checkbox" [checked]="column.followup" disabled />
        </ng-template>
        <ng-template
          kendoGridEditTemplate
          let-dataItem="dataItem"
          let-column="column"
          let-formGroup="formGroup"
        >
          <input type="checkbox" [formControl]="formGroup.get(column.field)" />
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-command-column title="Action" width="160" gdAdminOnly>
        <ng-template
          kendoGridCellTemplate
          let-isNew="isNew"
          let-dataItem="dataItem"
        >
          <div class="flex gap-2">
            <button kendoGridEditCommand [primary]="true" kendoButton look="flat" size="small" gdAdminOnly>
              <span class="fas fa-edit"></span> Edit
            </button>
            <button kendoGridSaveCommand kendoButton look="flat" size="small" [disabled]="formGroup?.invalid" gdAdminOnly>
              <span class="fas fa-save"></span> Save
            </button>
            <button kendoGridCancelCommand kendoButton look="flat" size="small" gdAdminOnly>
              <span class="fas fa-times"></span> Cancel
            </button>
          </div>
        </ng-template>
      </kendo-grid-command-column>
    </kendo-grid>
  </div>
</div>
